import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Suspensions = class Suspensions extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-suspensions';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.currentLocation = this.$element.find('.js-location-code:checked').val();
        this.clubName = this.$element.find('.js-clubname');
    }

    render() {
        this.setVars();

        $(".search-btn").on("click", function () {
            $("#searchResults").empty();
        });

        this.$element
            .find( '.js-location-code' )
            .on( 'change', ( event ) => {
                this.currentLocation = $( event.currentTarget ).val();

                if ( this.clubName.val().length >= 3 ) this.getClubs();
            } );

        this.clubName.on("keyup", () => {
            if ( this.clubName.val().length < 3 ) return;

            this.getClubs();
        });

        $("#searchPlayersBtn").on("click", function () {
            $.ajax({
                context: this,
                type: "POST",
                url: '/suspensions/searchplayers',
                data: $('#searchPlayersForm').serialize(),
                success: function (result) {
                    $("#searchPlayersFormResults").html( this.wrapWtihArticleTable( result ) );
                    this.$window.trigger('content:updated');
                },
                error: function () {

                }
            });
        }.bind(this));

        $("#searchLevelsBtn").on("click", function () {
            $.ajax({
                context: this,
                type: "POST",
                url: '/suspensions/searchlevels',
                data: $('#searchLevelsForm').serialize(),
                success: function (result) {
                    $("#searchLevelsFormResults").html( this.wrapWtihArticleTable( result ) );
                    this.$window.trigger('content:updated');
                },
                error: function () {

                }
            });
        }.bind(this));

        $("#searchClubsBtn").on("click", function(){
            $.ajax({
                context: this,
                type: "POST",
                url: '/suspensions/searchclubs',
                data: $('#searchClubsForm').serialize(),
                success: function (result) {
                    $("#searchClubsFormResults").html( this.wrapWtihArticleTable( result ) );
                    this.$window.trigger('content:updated');
                },
                error: function () {

                }
            });
        }.bind(this));

    }

    getClubs() {
        let url = '/suspensions/getclubs/' + $('#ClubName').val();

        if ( this.currentLocation ) {
            url += '/' + this.currentLocation;
        }

        $.ajax({
            url,
            dataType: "json",
            type: "GET",
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                $("#ClubId").empty();
                $.each(data.SearchResults, function(index, item) {
                    $("#ClubId").append($('<option></option>').text(item.Text).val(item.Value));
                });
            }
        });
    }

    wrapWtihArticleTable( content ) {
        return '<div class="fa-article-table" data-fa-article-table>' + content + '</div>'
    }
};



// WEBPACK FOOTER //
// ./components/suspensions/scripts/suspensions.js